<template>
    <!-- Global notification live region, render this permanently at the end of the document -->
    <TransitionRoot as="template" :show="show" v-if="(($page.props.flash.error || Object.keys($page.props.errors).length > 0) || $page.props.flash.success) && show">
        <div class="relative z-[12000]">
            <div id="alert" :role="($page.props.flash.error || Object.keys($page.props.errors).length > 0) ? 'alert' : 'status'" :aria-live="($page.props.flash.error || Object.keys($page.props.errors).length > 0) ? 'assertive' : 'polite'" class="pointer-events-none fixed inset-x-2 inset-y-16 flex items-end px-4 py-6 sm:items-start sm:p-6">
                <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
                    <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                        <div :class="[($page.props.flash.error || Object.keys($page.props.errors).length > 0) ? 'bg-red-50' : 'bg-green-50', 'pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5']">
                            <div class="p-4">
                                <div class="flex items-start">
                                    <div class="flex-shrink-0">
                                        <font-awesome-icon v-if="$page.props.flash.error || Object.keys($page.props.errors).length > 0" :icon="faCircleX()" class="text-red-400" aria-hidden="true" />
                                        <font-awesome-icon v-if="$page.props.flash.success" :icon="faCheckCircle()" class="h-6 w-6 text-green-400" aria-hidden="true" />
                                    </div>
                                    <div class="ml-3 w-0 flex-1 pt-0.5">
                                        <p class="text-sm font-medium text-gray-900">
                                            <span class="text-red-700" v-if="$page.props.flash.error" v-html="$page.props.flash.error">
                                            </span>
                                            <span class="text-red-700" v-else-if="Object.keys($page.props.errors).length > 0">
                                                <h3 class="text-sm font-bold text-red-800" v-if="Object.keys($page.props.errors).length === 1">There is one form error.</h3>
                                                <h3 class="text-sm font-bold text-red-800" v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</h3>
                                                Please scroll down the page, review your information, fix any errors and click the Save button again.
                                            </span>

                                            <span v-if="$page.props.flash.success">
                                                {{ $page.props.flash.success }}
                                            </span>
                                        </p>
                                    </div>
                                    <div :class="[($page.props.flash.error || Object.keys($page.props.errors).length > 0) ? 'bg-red-50' : 'bg-green-50', 'ml-4 flex flex-shrink-0']">
                                        <button id="alert-close-button" type="button" @click="show = false" :class="[($page.props.flash.error || Object.keys($page.props.errors).length > 0) ? 'bg-red-50' : 'bg-green-50', 'inline-flex rounded-md text-gray-400 hover:text-gray-500']">
                                            <span class="sr-only">Close</span>
                                            <font-awesome-icon :icon="faXmark()" class="h-5 w-5" aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </div>
    </TransitionRoot>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faCheckCircle, faXmark} from "@fortawesome/pro-light-svg-icons";
import {faCircleX} from "@fortawesome/pro-solid-svg-icons/faCircleX";

export default {
    methods: {
        faCircleX() {
            return faCircleX
        },
        faCheckCircle() {
            return faCheckCircle
        },
        faXmark() {
            return faXmark
        }
    },
    components: {
        FontAwesomeIcon,
    },
    data() {
        return {
            show: true,
        }
    },
    watch: {
        '$page.props.flash': {
            handler() {
                this.show = true
                setTimeout(() => {
                    this.show = false
                }, 7000);
            },
            deep: true,
        },
    },
}
</script>
